export default __webpack_public_path__ + "static/media/sliderImg4.f6f8b533.jpg";